define(function(require, exports, module) {
    'use strict';
    var BaseReplacerView = require('common/base.replacer.view');
    var core = require('core');
    var StickyFooterModelInstance = require('replacers/totalcasino-theme/sticky-footer/base.sticky-footer.model.instance');

    module.exports = BaseReplacerView.extend({

        model: StickyFooterModelInstance,

        render: function() {
            this.model.getRecentlyPlayedGames().done(function() {
                this.games = this.model.get('recentGames');
                this.$el.html(this.tmpl('recent', this.games));
                core.trigger('footer-games:loaded', this.$el);
            }.bind(this));
            return this;
        }

    }, {
        nameOfReplacers: [
            'STICKY_FOOTER_RECENTLY'
        ]
    });
});
